import Listar from "./Listar";

export default { Listar };
